import { Component, Input } from "@angular/core";

import { TopicPreviewInfo } from "../../../../../../common/interfaces/sayso-preview";

@Component({
  selector: "onsip-mobile-topics-list-preview",
  templateUrl: "./mobile-topics-list-preview/mobile-topics-list-preview.component.html",
  styleUrls: ["./mobile-topics-list-preview/mobile-topics-list-preview.component.scss"],
  standalone: false
})
export class MobileTopicsListPreviewComponent {
  @Input() accentColor!: string;
  @Input() topics: Array<TopicPreviewInfo> = [];
}
